import {Component, Inject, OnInit} from '@angular/core';
import {Ofwca} from '../../../shared/interface/ofwca';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Contract} from '../../../shared/interface/contract';

export interface RegistrationAddDialogData {
  ofwcaObject?: Ofwca;
  contractObject?: Contract;
}

@Component({
  selector: 'app-registration-add-dialog',
  templateUrl: './registration-add-dialog.component.html',
  styleUrls: ['./registration-add-dialog.component.scss']
})
export class RegistrationAddDialogComponent implements OnInit {
  ofwcaObject?: Ofwca = null;
  contractObject?: Contract = null;

  constructor(
    public dialogRef: MatDialogRef<RegistrationAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RegistrationAddDialogData,
  ) {
    this.ofwcaObject = data.ofwcaObject;
    this.contractObject = data.contractObject;
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
